



































































import './Modal.scss'
import { KisweButton, KisweIcon } from '@/modules/kisweui/components'
import { defineComponent } from '@vue/composition-api'
import { KisweSize } from '@/modules/kisweui/types'

export default defineComponent({
  name: 'Modal',
  components: {
    KisweButton,
    KisweIcon
  },
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    beta: {
      type: Boolean,
      required: false,
      default: false
    },
    submitText: {
      type: String,
      required: false,
      default: 'Submit'
    },
    cancelText: {
      type: String,
      required: false,
      default: 'Cancel'
    },
    showClose: {
      type: Boolean,
      required: false,
      default: true
    },
    showCancel: {
      type: Boolean,
      required: false,
      default: true
    },
    showFinish: {
      type: Boolean,
      required: false,
      default: true
    },
    outsideClose: {
      type: Boolean,
      required: false,
      default: true
    },
    buttonActive: {
      type: Boolean,
      required: false,
      default: true
    },
    width: {
      type: String,
      required: false
    },
    height: {
      type: String,
      required: false
    },
    customPopup: {
      type: Boolean,
      required: false,
      default: false
    },
    customClass: {
      type: String,
      required: false,
      default: ''
    },
    buttonSize:{
      type: String as () => KisweSize,
      required: false,
      default: KisweSize.Small,
      validator: (value: KisweSize) => Object.values(KisweSize).includes(value)
    },
    isSubmitLoading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  created () {
    // @keyup.esc isn't reliable for triggering close
    // this works reliably
    document.onkeydown = evt => {
      const keyEvent = (evt ? evt : window.event) as KeyboardEvent|undefined
      if (keyEvent === undefined) return
      if (keyEvent.keyCode === 27) this.close()
    }
  },
  beforeDestroy () {
    document.onkeydown = null
  },
  computed: {
    style (): Partial<CSSStyleDeclaration> {
      const modalStyle: Partial<CSSStyleDeclaration> = {}
      if (this.width !== undefined) {
        modalStyle.width = this.width
      }
      if (this.height !== undefined) {
        modalStyle.height = this.height
      }
      return modalStyle
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    closeFromOutside () {
      if (this.outsideClose) this.close()
    },
    submit () {
      if (this.buttonActive) {
        this.$emit('submitted')
      }
    }
  }
})
